import { createInput, MountTarget, newDialog, readConfig } from './utils/elements';

export const ROOSTER_EDIT_SELECTOR = '.cds-lrn-rooster';

interface RoosterConfig {
  rows: number;
  cols: number;
}

export function roosterDialog(insertHtml: (html: string) => void, mountTarget?: MountTarget, existingEl?: HTMLElement) {
  const dialog = newDialog('Rooster maken', () => insertHtml(''), mountTarget);

  const rows = createInput('rows', 'Aantal rijen', 'number');
  const cols = createInput('cols', 'Aantal kolommen', 'number');

  if (existingEl) {
    const cfg = readConfig<RoosterConfig>(existingEl, { rows: 0, cols: 0 });
    if (cfg.rows) rows.setValue(cfg.rows);
    if (cfg.cols) cols.setValue(cfg.cols);
  }

  const group = document.createElement('div');
  group.classList.add('flex', 'gap-s', 'items-center');

  group.append(rows.field, cols.field);

  let config = createConfig(+rows.value() || 0, +cols.value() || 0);

  rows.field.addEventListener('change', function (event) {
    if (rows.value() && cols.value()) {
      config = createConfig(+rows.value(), +cols.value());
      dialog.querySelector('#config-table').replaceWith(config);
    }
  });
  cols.field.addEventListener('change', function (event) {
    if (rows.value() && cols.value()) {
      config = createConfig(+rows.value(), +cols.value());
      dialog.querySelector('#config-table').replaceWith(config);
    }
  });

  dialog.querySelector('#cds-dialog-content').append(group, config);

  dialog.addEventListener('onSubmit', () => {
    const table = createTable(config, { rows: +rows.value(), cols: +cols.value() });

    insertHtml(table);
  });
}


function createTable(config: HTMLTableElement, persistedConfig: RoosterConfig) {
  const table = config;
  table.classList.add('cds-lrn-rooster');
  table.setAttribute('data-cb-config', JSON.stringify(persistedConfig));
  table.querySelectorAll('input').forEach((input) => {
    input.remove();
  });
  table.querySelectorAll('tr')[0].remove();
  table.querySelectorAll('tr').forEach((tr) => {
    tr.querySelectorAll('td')[0].remove();
  });
  table.querySelectorAll('td').forEach((td) => {
    td.classList.remove('icon-size-2xl');
    td.classList.add('column-min-w-m', 'column-w-m', 'row-h-m');
  });

  return table.outerHTML;
}

function createConfig(rows: number, cols: number) {
  const table = document.createElement('table');
  table.classList.add('text-center', 'w-fit');
  table.setAttribute('id', 'config-table');

  const firstRow = document.createElement('tr');
  for (let j = 0; j < cols + 1; j++) {
    const td = document.createElement('td');
    firstRow.append(td);

    if (j === 0) continue;

    const radio = document.createElement('input');
    radio.setAttribute('type', 'radio');
    radio.classList.add('icon-size-m');
    radio.setAttribute('name', 'accent');
    radio.setAttribute('value', `acc-col-${j}`);

    radio.addEventListener('click', function (event) {
      table.querySelectorAll('td').forEach(removeAccentBorders);
      if (radio.checked) {
        const accentCells = table.querySelectorAll(`tr:not(:first-child) > td:nth-child(${j + 1})`);

        accentCells.forEach((td, index) => {
          if (index === 0) {
            td.classList.add('border-bs-2', 'border-bs-primary');
          }
          if (index === accentCells.length - 1) {
            td.classList.add('border-be-2', 'border-be-primary');
          }
          td.classList.add('border-i-2', 'border-i-primary');
        });
      }
    });

    td.append(radio);
  }
  table.append(firstRow);

  for (let i = 0; i < rows; i++) {
    const tr = document.createElement('tr');

    const radio = document.createElement('input');
    radio.setAttribute('type', 'radio');
    radio.classList.add('icon-size-m');
    radio.setAttribute('name', 'accent');
    radio.setAttribute('value', `acc-row-${i}`);

    radio.addEventListener('click', function (event) {
      table.querySelectorAll('td').forEach(removeAccentBorders);

      if (radio.checked) {
        const accentCells = tr.querySelectorAll('td:not(:first-child)');

        accentCells.forEach((td, index) => {
          if (index === 0) {
            td.classList.add('border-is-2', 'border-is-primary');
          }
          if (index === accentCells.length - 1) {
            td.classList.add('border-ie-2', 'border-ie-primary');
          }
          td.classList.add('border-b-2', 'border-b-primary');
        });
      }
    });

    const td = document.createElement('td');
    td.append(radio);
    tr.append(td);

    for (let j = 0; j < cols; j++) {
      const td = document.createElement('td');
      td.classList.add('icon-size-2xl');

      const checkbox = document.createElement('input');
      checkbox.setAttribute('type', 'checkbox');

      checkbox.classList.add('icon-size-m');

      checkbox.addEventListener('click', function (event) {
        if (checkbox.checked) {
          td.classList.add('border');
        } else {
          td.classList.remove('border');
        }
      });
      td.append(checkbox);

      tr.append(td);
    }
    table.append(tr);
  }

  return table;
}

const removeAccentBorders = (td) => {
  td.classList.remove(
    'border-b-2',
    'border-ie-2',
    'border-is-2',
    'border-b-primary',
    'border-is-primary',
    'border-ie-primary',
    'border-i-2',
    'border-be-2',
    'border-bs-2',
    'border-i-primary',
    'border-bs-primary',
    'border-be-primary'
  );
};
